<template>
  <v-dialog
    v-model="show"
    width="514"
    content-class="LogModal">
    <template
      v-slot:default>
      <v-card
        class="fill-height rounded-xl"
        min-height="300">
        <v-container
          fluid>
          <v-row>
            <v-col
              cols="6"
              class="d-flex justify-start pl-4">
              <span
                class="text-h6 font-weight-bold primary--text">
                Log
              </span>
            </v-col>
            <v-col
              cols="6"
              class="d-flex justify-end">
              <v-icon
                size="25"
                color="muted-accent"
                @click="close">
                close
              </v-icon>
            </v-col>
          </v-row>
          <v-row>
            <v-divider />
          </v-row>
          <v-row>
            <v-col
              cols="12"
              class="pa-0">
              <JsonViewer
                id="LogJson"
                class="overflow-auto"
                style="max-height: calc(-250px + 100vh)"
                :jsonData="log"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-divider />
          </v-row>
          <v-card-actions class="mt-2" />
        </v-container>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import JsonViewer from '@/components/JsonViewer/JsonViewer.vue';
export default {
  name: "LogModal",

  components: {
    JsonViewer,
  },

  data: () => ({
    show: false,
    log: null,
  }),

  methods: {
    open(log) {
      this.log = log;
      this.show = true;
    },

    close() {
      this.log = null;
      this.show = false;
    },
  },
}
</script>

<style lang="scss" scoped>
.LogModal {
  border-radius: 30px !important;

  @media (min-width: 960px) {
    position: absolute !important;
    right: 13%;
    margin: 0 !important;
  }
}
#LogJson {
  background: var(--v-muted-base) !important;
  > .language-json {
    background: var(--v-muted-base) !important;
    > .token.property     { color: var(--v-info-base); }
    > .token.string       { color: var(--v-error-base); }
    > .token.number       { color: var(--v-primary-base); }
    > .token.boolean      { color: var(--v-warning-base); }
    > .token.null         { color: var(--v-error-base); }
    > .token.punctuation  { color: var(--v-shadow-base); }
    > .token.operator     { color: var(--v-muted-base); }
    > .token.keyword      { color: var(--v-error-base); }
    }
}
</style>
